import { getStore } from './store';
export default function getActiveCharm() {
    return getStore().activeCharm;
}
//# sourceMappingURL=getActiveCharm.js.map